import { createBackendClient } from "@kozien/shared";

export const backendClient = createBackendClient(
    import.meta.env.VITE_BACKEND_GRAPHQL_ENDPOINT,
    import.meta.env.VITE_BACKEND_API_KEY,
);
